import api from './authService';

export const shopkeeperService = {
  getAll: (page = 1, limit = 10, search = '') =>
    api.get(`/admin/shops?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`),
  getById: (id: string) => api.get(`/admin/shops/${id}`),
  create: (data: FormData) => api.post('/admin/shops', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id: string, data: any) => api.patch(`/admin/shops/${id}`, data),
};

export const staffService = {
  getAll: (staffType?: string) => {
    const url = staffType ? `/admin/staff?staffType=${staffType}` : '/admin/staff';
    return api.get(url);
  },
  create: (data: any) => api.post('/admin/staff', data),
  updateStatus: (id: string, status: string) =>
    api.patch(`/admin/staff/${id}/status`, { status }),
  updateEmail: (id: string, email: string) =>
    api.patch(`/admin/staff/${id}/email`, { email }),
};

export const paymentService = {
  getAll: (status?: string) => {
    const url = status ? `/admin/payments?status=${status}` : '/admin/payments';
    return api.get(url);
  },
  approve: (id: string) => api.patch(`/admin/payments/${id}/approve`),
  reject: (id: string, reason: string) =>
    api.patch(`/admin/payments/${id}/reject`, { rejectionReason: reason }),
};

export const complaintService = {
  getAll: (status?: string, category?: string) => {
    let url = '/admin/complaints?';
    if (status) url += `status=${encodeURIComponent(status)}&`;
    if (category) url += `category=${encodeURIComponent(category)}`;
    return api.get(url);
  },
  assign: (id: string, staffId: string) =>
    api.patch(`/admin/complaints/${id}/assign`, { staffId }),
};

export const attendanceService = {
  getAll: (params?: { startDate?: string; endDate?: string; staffType?: string; staffId?: string }) => {
    let url = '/admin/attendance?';
    if (params?.startDate) url += `startDate=${params.startDate}&`;
    if (params?.endDate) url += `endDate=${params.endDate}&`;
    if (params?.staffType) url += `staffType=${params.staffType}&`;
    if (params?.staffId) url += `staffId=${params.staffId}`;
    return api.get(url);
  },
  getSummary: (params?: { startDate?: string; endDate?: string; staffType?: string; staffId?: string }) => {
    let url = '/admin/attendance/summary?';
    if (params?.startDate) url += `startDate=${params.startDate}&`;
    if (params?.endDate) url += `endDate=${params.endDate}&`;
    if (params?.staffType) url += `staffType=${params.staffType}&`;
    if (params?.staffId) url += `staffId=${params.staffId}`;
    return api.get(url);
  },
};

export const settingsService = {
  get: () => api.get('/admin/settings'),
  update: (data: any) => api.patch('/admin/settings', data),
  uploadQRCode: (file: File) => {
    const formData = new FormData();
    formData.append('qrCode', file);
    return api.post('/admin/settings/qr-code', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const dashboardService = {
  getStats: () => api.get('/admin/dashboard'),
};

export const notificationService = {
  send: (data: { title: string; body: string; targetRole?: string; userId?: string }) =>
    api.post('/admin/notifications/send', data),
  registerDeviceToken: (token: string, platform: 'web' | 'android' | 'ios' = 'web') =>
    api.post('/admin/device-token', { token, platform }),
  list: (params?: { unreadOnly?: boolean; all?: boolean; page?: number; limit?: number }) => {
    const searchParams = new URLSearchParams();
    if (params?.unreadOnly) searchParams.set('unreadOnly', 'true');
    if (params?.all) searchParams.set('all', 'true');
    if (params?.page) searchParams.set('page', String(params.page));
    if (params?.limit) searchParams.set('limit', String(params.limit));
    const query = searchParams.toString();
    return api.get(`/admin/notifications${query ? `?${query}` : ''}`);
  },
  markAsRead: (id: string) => api.post(`/admin/notifications/${id}/read`, {}),
};

export const vehicleService = {
  getAll: (search?: string) => {
    const url = search ? `/admin/vehicles?search=${encodeURIComponent(search)}` : '/admin/vehicles';
    return api.get(url);
  },
};
